<div class="payment-form">
  <!-- Trial Info Banner -->
  <div class="trial-banner">
    <mat-icon>celebration</mat-icon>
    <div class="banner-content">
      <strong>Start with a 90-day free trial</strong>
      <p>Add a payment method now to ensure uninterrupted service after your trial. You won't be charged today.</p>
    </div>
  </div>

  <!-- Card Input Section -->
  <div class="form-section">
    <h3 class="section-title">Payment Details</h3>

    <label class="visually-hidden" for="onboarding-name-on-card">Name on Card</label>
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Name on Card</mat-label>
      <input matInput id="onboarding-name-on-card" [formControl]="nameOnCardControl" placeholder="John Smith" required>
    </mat-form-field>

    <fieldset class="card-element-container">
      <legend class="card-label">Card Information</legend>
      <div id="card-element" class="card-element"></div>
      <div class="card-error" *ngIf="cardError">
        <mat-icon>error</mat-icon>
        {{ cardError }}
      </div>
    </fieldset>
  </div>

  <!-- Optional Billing Address -->
  <div class="form-section">
    <h3 class="section-title">
      Billing Address 
      <span class="optional-badge">Optional</span>
    </h3>

    <div [formGroup]="billingAddressGroup">
      <label class="visually-hidden" for="onboarding-billing-line1">Street Address</label>
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Street Address</mat-label>
        <input matInput id="onboarding-billing-line1" formControlName="line1" placeholder="123 Main St">
      </mat-form-field>

      <div class="form-row">
        <label class="visually-hidden" for="onboarding-billing-city">City</label>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>City</mat-label>
          <input matInput id="onboarding-billing-city" formControlName="city" placeholder="New York">
        </mat-form-field>

        <label class="visually-hidden" for="onboarding-billing-state">State</label>
        <mat-form-field appearance="outline" class="quarter-width">
          <mat-label>State</mat-label>
          <input matInput id="onboarding-billing-state" formControlName="state" placeholder="NY">
        </mat-form-field>

        <label class="visually-hidden" for="onboarding-billing-postal">ZIP Code</label>
        <mat-form-field appearance="outline" class="quarter-width">
          <mat-label>ZIP Code</mat-label>
          <input matInput id="onboarding-billing-postal" formControlName="postal_code" placeholder="10001">
        </mat-form-field>
      </div>
    </div>
  </div>

  <!-- Secure Payment Notice -->
  <div class="security-notice">
    <mat-icon>lock</mat-icon>
    <span>Your payment information is encrypted and secure. Powered by <strong>Stripe</strong>.</span>
  </div>

  <!-- Loading State -->
  <div class="processing-overlay" *ngIf="isProcessing">
    <mat-spinner diameter="32"></mat-spinner>
    <span>Processing...</span>
  </div>
</div>
